import { initializeApolloClient } from '@crehana/apollo-client';
export var apolloClient = /*#__PURE__*/initializeApolloClient({
  pageKey: 'feature-flags'
});